import defaultReducer from "./defaultReducer";

export default defaultReducer("FRS_CLIENT_SECRET_MODAL", {
  open: false,
});
